import React, { forwardRef, useImperativeHandle } from 'react';
import classNames from 'classnames';
import { Modal } from 'ncoded-component-library';
import {
  ModalProps,
  ModalRef,
} from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import useCallbackRef from 'hooks/useCallbackRef';
import { useTranslation } from 'react-i18next';
import { MAX_STARRED_FILES } from 'router/subrouters/DataRoom/models/DataRoomNode';
import UnstarDocumentsForm from './compnonents/UnstarDocumentsForm';

import './UnstarDocumentsModal.styles.scss';

type UnstarDocumentsModalProps = {
  className?: string;
} & ModalProps;

const UnstarDocumentsModal: React.ForwardRefRenderFunction<
  ModalRef,
  UnstarDocumentsModalProps
> = (props, ref) => {
  const { className, ...rest } = props;

  const [modal, modalRef] = useCallbackRef<ModalRef>();

  useImperativeHandle(ref, () => modal, [modal]);

  const classes = classNames('unstar-documents-modal', className);

  const { t } = useTranslation();

  return (
    <Modal
      ref={modalRef}
      className={classes}
      title={t('starLimitReached')}
      {...rest}
    >
      <p>{t('youCanStarUpToNFiles', { count: MAX_STARRED_FILES })}</p>

      {modal?.openState && <UnstarDocumentsForm onClose={modal?.close} />}
    </Modal>
  );
};

export default forwardRef(UnstarDocumentsModal);
